import { render, staticRenderFns } from "./foresterPatrol.vue?vue&type=template&id=2adfd788&scoped=true&"
import script from "./foresterPatrol.vue?vue&type=script&lang=js&"
export * from "./foresterPatrol.vue?vue&type=script&lang=js&"
import style0 from "./foresterPatrol.vue?vue&type=style&index=0&id=2adfd788&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adfd788",
  null
  
)

export default component.exports